import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ContentChild,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import { NgpDialog, NgpDialogOverlay } from 'ng-primitives/dialog';

import {
  SuiDialogLeftHeaderSlot,
  SuiDialogLeftContentSlot,
  SuiDialogRightHeaderSlot,
  SuiDialogRightContentSlot,
  SuiDialogRightFooterSlot,
} from './sui-dialog-tabs-slots';

import { DialogLayoutBase } from '../dialog-layout-base';

@Component({
  selector: 'sui-dialog-tabs',
  standalone: true,
  imports: [NgTemplateOutlet, NgpDialog, NgpDialogOverlay],
  templateUrl: './sui-dialog-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./sui-dialog-tabs.component.scss'],
})
export class SuiDialogTabsComponent extends DialogLayoutBase {
  @ContentChild(SuiDialogLeftHeaderSlot, {
    read: TemplateRef,
    descendants: true,
  })
  leftHeaderTpl?: TemplateRef<any>;

  @ContentChild(SuiDialogLeftContentSlot, {
    read: TemplateRef,
    descendants: true,
  })
  leftContentTpl?: TemplateRef<any>;

  @ContentChild(SuiDialogRightHeaderSlot, {
    read: TemplateRef,
    descendants: true,
  })
  rightHeaderTpl?: TemplateRef<any>;

  @ContentChild(SuiDialogRightContentSlot, {
    read: TemplateRef,
    descendants: true,
  })
  rightContentTpl?: TemplateRef<any>;

  @ContentChild(SuiDialogRightFooterSlot, {
    read: TemplateRef,
    descendants: true,
  })
  rightFooterTpl?: TemplateRef<any>;

  // * Size class uses component-specific prefix
  protected get sizeClass(): string {
    if (!this.config.size) return '';
    return `sui-dialog-tabs--${this.config.size}`;
  }
}
